var $ = Object.defineProperty, j = Object.defineProperties;
var B = Object.getOwnPropertyDescriptors;
var A = Object.getOwnPropertySymbols;
var H = Object.prototype.hasOwnProperty, I = Object.prototype.propertyIsEnumerable;
var q = (t, r, o) => r in t ? $(t, r, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[r] = o, a = (t, r) => {
  for (var o in r || (r = {}))
    H.call(r, o) && q(t, o, r[o]);
  if (A)
    for (var o of A(r))
      I.call(r, o) && q(t, o, r[o]);
  return t;
}, c = (t, r) => j(t, B(r));
import { jsx as v, Fragment as C } from "react/jsx-runtime";
import { useState as E, useRef as F, useEffect as N } from "react";
import { b as U, k as V } from "./factory-ueRxoNOV.js";
import z from "react-dom";
import { a as G, u as J } from "./use-reduced-motion-C9DbPZfj.js";
const f = (t) => ({
  in: { opacity: 1, transform: "scale(1)" },
  out: { opacity: 0, transform: `scale(.9) translateY(${t === "bottom" ? 10 : -10}px)` },
  transitionProperty: "transform, opacity"
}), x = {
  fade: {
    in: { opacity: 1 },
    out: { opacity: 0 },
    transitionProperty: "opacity"
  },
  "fade-up": {
    in: { opacity: 1, transform: "translateY(0)" },
    out: { opacity: 0, transform: "translateY(30px)" },
    transitionProperty: "opacity, transform"
  },
  "fade-down": {
    in: { opacity: 1, transform: "translateY(0)" },
    out: { opacity: 0, transform: "translateY(-30px)" },
    transitionProperty: "opacity, transform"
  },
  "fade-left": {
    in: { opacity: 1, transform: "translateX(0)" },
    out: { opacity: 0, transform: "translateX(30px)" },
    transitionProperty: "opacity, transform"
  },
  "fade-right": {
    in: { opacity: 1, transform: "translateX(0)" },
    out: { opacity: 0, transform: "translateX(-30px)" },
    transitionProperty: "opacity, transform"
  },
  scale: {
    in: { opacity: 1, transform: "scale(1)" },
    out: { opacity: 0, transform: "scale(0)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "scale-y": {
    in: { opacity: 1, transform: "scaleY(1)" },
    out: { opacity: 0, transform: "scaleY(0)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "scale-x": {
    in: { opacity: 1, transform: "scaleX(1)" },
    out: { opacity: 0, transform: "scaleX(0)" },
    common: { transformOrigin: "left" },
    transitionProperty: "transform, opacity"
  },
  "skew-up": {
    in: { opacity: 1, transform: "translateY(0) skew(0deg, 0deg)" },
    out: { opacity: 0, transform: "translateY(-20px) skew(-10deg, -5deg)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "skew-down": {
    in: { opacity: 1, transform: "translateY(0) skew(0deg, 0deg)" },
    out: { opacity: 0, transform: "translateY(20px) skew(-10deg, -5deg)" },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "rotate-left": {
    in: { opacity: 1, transform: "translateY(0) rotate(0deg)" },
    out: { opacity: 0, transform: "translateY(20px) rotate(-5deg)" },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "rotate-right": {
    in: { opacity: 1, transform: "translateY(0) rotate(0deg)" },
    out: { opacity: 0, transform: "translateY(20px) rotate(5deg)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "slide-down": {
    in: { opacity: 1, transform: "translateY(0)" },
    out: { opacity: 0, transform: "translateY(-100%)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "slide-up": {
    in: { opacity: 1, transform: "translateY(0)" },
    out: { opacity: 0, transform: "translateY(100%)" },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "slide-left": {
    in: { opacity: 1, transform: "translateX(0)" },
    out: { opacity: 0, transform: "translateX(100%)" },
    common: { transformOrigin: "left" },
    transitionProperty: "transform, opacity"
  },
  "slide-right": {
    in: { opacity: 1, transform: "translateX(0)" },
    out: { opacity: 0, transform: "translateX(-100%)" },
    common: { transformOrigin: "right" },
    transitionProperty: "transform, opacity"
  },
  pop: c(a({}, f("bottom")), {
    common: { transformOrigin: "center center" }
  }),
  "pop-bottom-left": c(a({}, f("bottom")), {
    common: { transformOrigin: "bottom left" }
  }),
  "pop-bottom-right": c(a({}, f("bottom")), {
    common: { transformOrigin: "bottom right" }
  }),
  "pop-top-left": c(a({}, f("top")), {
    common: { transformOrigin: "top left" }
  }),
  "pop-top-right": c(a({}, f("top")), {
    common: { transformOrigin: "top right" }
  })
}, W = {
  entering: "in",
  entered: "in",
  exiting: "out",
  exited: "out",
  "pre-exiting": "out",
  "pre-entering": "out"
};
function K({
  transition: t,
  state: r,
  duration: o,
  timingFunction: i
}) {
  const e = {
    WebkitBackfaceVisibility: "hidden",
    willChange: "transform, opacity",
    transitionDuration: `${o}ms`,
    transitionTimingFunction: i
  };
  return typeof t == "string" ? t in x ? a(a(a({
    transitionProperty: x[t].transitionProperty
  }, e), x[t].common), x[t][W[r]]) : {} : a(a(a({
    transitionProperty: t.transitionProperty
  }, e), t.common), t[W[r]]);
}
function L({
  duration: t,
  exitDuration: r,
  timingFunction: o,
  mounted: i,
  onEnter: e,
  onExit: s,
  onEntered: w,
  onExited: T,
  enterDelay: y,
  exitDelay: l
}) {
  const Y = U(), O = G(), u = Y.respectReducedMotion ? O : !1, [b, g] = E(u ? 0 : t), [d, m] = E(i ? "entered" : "exited"), R = F(-1), S = F(-1), h = F(-1);
  function X() {
    window.clearTimeout(R.current), window.clearTimeout(S.current), cancelAnimationFrame(h.current);
  }
  const D = (n) => {
    X();
    const p = n ? e : s, P = n ? w : T, k = u ? 0 : n ? t : r;
    g(k), k === 0 ? (typeof p == "function" && p(), typeof P == "function" && P(), m(n ? "entered" : "exited")) : h.current = requestAnimationFrame(() => {
      z.flushSync(() => {
        m(n ? "pre-entering" : "pre-exiting");
      }), h.current = requestAnimationFrame(() => {
        typeof p == "function" && p(), m(n ? "entering" : "exiting"), R.current = window.setTimeout(() => {
          typeof P == "function" && P(), m(n ? "entered" : "exited");
        }, k);
      });
    });
  }, _ = (n) => {
    if (X(), typeof (n ? y : l) != "number") {
      D(n);
      return;
    }
    S.current = window.setTimeout(
      () => {
        D(n);
      },
      n ? y : l
    );
  };
  return J(() => {
    _(i);
  }, [i]), N(
    () => () => {
      X();
    },
    []
  ), {
    transitionDuration: b,
    transitionStatus: d,
    transitionTimingFunction: o || "ease"
  };
}
function Q({
  keepMounted: t,
  transition: r = "fade",
  duration: o = 250,
  exitDuration: i = o,
  mounted: e,
  children: s,
  timingFunction: w = "ease",
  onExit: T,
  onEntered: y,
  onEnter: l,
  onExited: Y,
  enterDelay: O,
  exitDelay: u
}) {
  const b = V(), { transitionDuration: g, transitionStatus: d, transitionTimingFunction: m } = L({
    mounted: e,
    exitDuration: i,
    duration: o,
    timingFunction: w,
    onExit: T,
    onEntered: y,
    onEnter: l,
    onExited: Y,
    enterDelay: O,
    exitDelay: u
  });
  return g === 0 || b === "test" ? e ? /* @__PURE__ */ v(C, { children: s({}) }) : t ? s({ display: "none" }) : null : d === "exited" ? t ? s({ display: "none" }) : null : /* @__PURE__ */ v(C, { children: s(
    K({
      transition: r,
      duration: g,
      state: d,
      timingFunction: m
    })
  ) });
}
Q.displayName = "@mantine/core/Transition";
export {
  Q as T
};
